"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const graphql_tag_1 = __importDefault(require("graphql-tag"));
exports.default = (0, graphql_tag_1.default)`
  fragment userListConnectionSchemaFields on UserListConnectionSchema {
    id
    allowsCommonNotifications
    allowsPrivateNotifications
    allowsPushNotifications
    markAsNotSpammersDate
    allowTelegramMessage
    firstName
    lastName
    middleName
    juristicPersonInn
    juristicPersonLegalForm
    juristicPersonName
    juristicPersonOgrn
    fullName
    isRegistered
    active
    personType
    role
    accessLevel
    membership
    hasPrivateProfile
    nickname
    avatarUrl
    avatarColor
    avatarBorderColor
    avatarText
    avatarDisplayName
    showMyAvatar
    ownershipAddress
    notificationWarning {
      description
    }
    allowMeeting
    whyNotAllowMeeting
    ownershipPercent
    account {
      id
      email {
        id
        type
        value
        isVerified
        verificationSendTime
      }
      phone {
        id
        type
        value
        isVerified
        verificationSendTime
      }
    }
  }
`;